(function () {
    console.log("ℹ️ [InfoPopup] Avvio...");

    const translations = {
      it: {
        measureLink: 'Scopri come prendere le misure',
        closePopup: 'Chiudi',
        buttonInfo: 'Mostra dettagli',
        tipi_colletto: 'Colletto / collar',
        misure_collo: 'Misure collo',
        tipi_polsini: "Tipi di Polsini",
        cucitura_camicia: "Cucitura camicia",
        bottoni: "Bottoni",
        misure_standard: "Misure standard",
        misure_su_corpo: "Misure su corpo",
        misure_su_camicia: "Misure su camicia",
        scarica_istruzioni: "Scarica le istruzioni",
        mostra_dettagli:"Mostra dettagli"
      },
      en: {
        measureLink: 'Learn how to take measurements',
        closePopup: 'Close',
        buttonInfo: 'Show details',
      },
      fr: {
        measureLink: 'Découvrez comment prendre les mesures',
        closePopup: 'Fermer',
        buttonInfo: 'Afficher les détails',
      },
    };

    const currentLang = window.Shopify?.locale || document.documentElement.lang || 'en';
    const t = translations[currentLang] || translations.en;
    
    const popupData = {
      "pplr-colletto": {
        title: t.tipi_colletto,
        html: `
          <div class="popup-grid">
            <div class="popup-item">
              <img src="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/misure_collo.jpg" alt="${t.misure_collo}">
              <img src="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/misure_collo_2.jpg?v=1760365590" alt="${t.misure_collo}">
              <!--p><strong>Classico Italiano</strong><br>3,8 cm / 2,5 cm / 7,2 cm / 9,5 cm</p-->
            </div>
            <!--div class="popup-item">
              <img src="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/misure_collo_2.jpg?v=1760365590" alt="${t.misure_collo}">
              <p><strong>Semi Francese Classico</strong><br>4,3 cm / 3,6 cm / 7 cm / 11,5 cm</p>
            </div-->
          </div>
        `
      },
      "pplr-polsini": {
        title: t.tipi_polsini,
        html: `
          <div class="popup-grid">
            <div class="popup-item">
              <img src="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/misure_polsi.jpg" alt="${t.tipi_polsini}">
              <!--p><strong>Polsino Rotondo</strong><br>Classico e versatile</p-->
            </div>
            <!--div class="popup-item">
              <img src="https://cdn-zeptoapps.com/product-personalizer/images/polsino-smussato.jpg" alt="Polsino smussato">
              <p><strong>Polsino Smussato</strong><br>Profilo elegante e moderno</p>
            </div-->
          </div>
        `
      },
      "pplr-cuciture": {
        title: t.cucitura_camicia,
        html: `
          <div class="popup-grid">
            <div class="popup-item">
              <img src="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/scelta_cucitura.jpg" alt="${t.cucitura_camicia}">
              <!--p><strong>Polsino Rotondo</strong><br>Classico e versatile</p-->
              <div class="scelta_cuciture">
              <span>1 mm</span>
              <span>3 mm</span>
              <span>6 mm</span>
              </div>
            </div>
          </div>
        `
      },
      "pplr-bottoni": {
        title: t.bottoni,
        html: `
          <div class="popup-grid">
            <div class="popup-item">
              <img src="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/info_bottoni.jpg?v=1760535850" alt="${t.bottoni}">
              <!--p><strong>Polsino Rotondo</strong><br>Classico e versatile</p-->
              <!--div class="scelta_cuciture">
              <span>1 mm</span>
              <span>3 mm</span>
              <span>6 mm</span>
              </div-->
            </div>
          </div>
        `
      },
      "pplr-misure": {
        title: t.misure_standard,
        html: `
          <div class="popup-grid">
            <div class="popup-item">
<div class="table-wrapper">

<table class="custom-fit-table" border="1" cellpadding="5" cellspacing="0">
  <thead>
    <tr>
      <th>TAGLIA / SIZE</th>
      <th>37</th><th>38</th><th>39</th><th>40</th><th>41</th><th>42</th><th>43</th><th>44</th><th>45</th>
      <th>46</th><th>47</th><th>48</th><th>49</th><th>50</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>Collo / Collar [cm]</td><td>37</td><td>38</td><td>39</td><td>40</td><td>41</td><td>42</td><td>43</td><td>44</td><td>45</td><td>46</td><td>47</td><td>48</td><td>49</td><td>50</td></tr>
    <tr><td>Collo / Collar [inches]</td><td>14½</td><td>15</td><td>15½</td><td>15¾</td><td>16</td><td>16½</td><td>17</td><td>17½</td><td>18</td><td>18½</td><td>19</td><td>19½</td><td>20</td><td>20½</td></tr>
    <tr><td>Spalle / Shoulders</td><td>42</td><td>43,4</td><td>44,5</td><td>45,8</td><td>47</td><td>48</td><td>49</td><td>50,5</td><td>51,5</td><td>52,9</td><td>54</td><td>55,3</td><td>56,4</td><td>57,6</td></tr>
    <tr><td>Torace / Chest</td><td>100,5</td><td>104,5</td><td>108,5</td><td>112,5</td><td>116,5</td><td>120,5</td><td>124,5</td><td>128,5</td><td>132,5</td><td>136,5</td><td>140,5</td><td>144,5</td><td>148,5</td><td>152,5</td></tr>
    <tr><td>Vita / Waist</td><td>85</td><td>89</td><td>93</td><td>97</td><td>101</td><td>105</td><td>109</td><td>113</td><td>117</td><td>121</td><td>125</td><td>129,3</td><td>133,3</td><td>137,3</td></tr>
    <tr><td>Bacino / Hips</td><td>97,5</td><td>101,5</td><td>105,5</td><td>109,5</td><td>113,5</td><td>117,5</td><td>121,5</td><td>125,5</td><td>129,5</td><td>133,5</td><td>137,5</td><td>141,5</td><td>145,5</td><td>149,5</td></tr>
    <tr><td>Lunghezza manica<br>Sleeve length</td><td>63,5</td><td>64</td><td>64,5</td><td>65</td><td>65,5</td><td>66</td><td>66,5</td><td>67</td><td>67,5</td><td>68</td><td>68,5</td><td>69</td><td>69,5</td><td>70</td></tr>
    <tr><td>Giromanica / Armhole</td><td>46,6</td><td>47,7</td><td>48,8</td><td>50</td><td>51,15</td><td>52,31</td><td>53,46</td><td>54,62</td><td>55,79</td><td>56,96</td><td>58,13</td><td>59,31</td><td>60,49</td><td>61,67</td></tr>
    <tr><td>Bicipite / Biceps</td><td>37,7</td><td>38,5</td><td>39,2</td><td>40,0</td><td>40,8</td><td>41,6</td><td>42,4</td><td>43,1</td><td>43,9</td><td>44,7</td><td>45,5</td><td>46,3</td><td>47,0</td><td>47,8</td></tr>
    <tr><td>Lunghezza camicia dietro<br>Shirt back length</td><td>76,5</td><td>77,5</td><td>78,5</td><td>79,5</td><td>80,5</td><td>81,5</td><td>82,5</td><td>83,5</td><td>84,5</td><td>85,5</td><td>86,5</td><td>87,5</td><td>88,5</td><td>89,5</td></tr>
    <tr><td>Polso da parte a parte<br>Cuff edge to edge</td><td>23</td><td>24</td><td>24</td><td>25</td><td>25</td><td>26</td><td>26</td><td>27</td><td>27</td><td>28</td><td>28</td><td>29</td><td>30</td><td>31</td></tr>
  </tbody>
</table>
</div>
<style>
  .table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.custom-fit-table {
  border-collapse: collapse;
  min-width: 1100px; /* forza la larghezza minima per lo scroll */
  font-size: 14px;
  font-family: Arial, sans-serif;
}

  .custom-fit-table th,
.custom-fit-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    white-space: nowrap;
  }

  .custom-fit-table th {
    background-color: #f0f0f0;
    font-weight: bold;
  }

  .custom-fit-table td:first-child,
.custom-fit-table th:first-child {
  width: 180px; /* puoi aumentare o ridurre a piacere */
  min-width: 180px;
    text-align: left;
    background-color: #f9f9f9;
    font-weight: bold;
    position: sticky;
    left: 0;
    z-index: 1;
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 2;
  }



  @media screen and (max-width: 768px) {
  .custom-fit-table {
    font-size: 13px;
  }

  .custom-fit-table td,
  .custom-fit-table th {
    padding: 6px;
  }

  .custom-fit-table td:first-child,
  .custom-fit-table th:first-child {
    min-width: 220px;
    max-width: 250px;
  }
}
</style>



            
              <!--img src="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/misure_custom_fit.jpg?v=1763118354" alt="${t.misure_standard}"-->
            </div>
          </div>
        `
      },
      "pplr-collo": {
        title: t.misure_su_corpo,
        html: `
          <div class="popup-grid">
            <div class="popup-item">
            <a href="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/misure_su_corpo.pdf?v=1763119733" target="_blank">${t.scarica_istruzioni}</a><br><br>
              <img src="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/misure_su_corpo.jpg?v=1763119627" alt="${t.misure_su_corpo}"><br><br>
              <h2>${t.misure_su_camicia}</h2>
            <a href="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/misure_su_camicie.pdf?v=1763139754" target="_blank">${t.scarica_istruzioni}</a><br><br>
              <img src="https://cdn.shopify.com/s/files/1/0943/7711/6032/files/misura_su_camicia.jpg?v=1763139755" alt="${t.misure_su_camicia}">
            </div>
          </div>
        `
      }
    };
  
    // 🔹 Crea popup (riutilizzabile)
    function createPopup() {
      if (document.getElementById("info-popup")) return;
      const popup = document.createElement("div");
      popup.id = "info-popup";
      popup.innerHTML = `
        <div class="info-popup-overlay"></div>
        <div class="info-popup-content">
          <button class="info-popup-close" aria-label="Chiudi">×</button>
          <div class="info-popup-inner"></div>
        </div>
      `;
      document.body.appendChild(popup);
  
      const overlay = popup.querySelector(".info-popup-overlay");
      const closeBtn = popup.querySelector(".info-popup-close");
  
      function closePopup() {
        popup.classList.remove("visible");
        setTimeout(() => popup.remove(), 300);
      }
  
      overlay.addEventListener("click", closePopup);
      closeBtn.addEventListener("click", closePopup);
    }
  
    // 🔹 Mostra popup dinamico
    function openInfoPopup(section) {
      const data = popupData[section];
      if (!data) return;
      createPopup();
      const popup = document.getElementById("info-popup");
      const inner = popup.querySelector(".info-popup-inner");
  
      inner.innerHTML = `<h2>${data.title}</h2>${data.html || ""}`;
      popup.classList.add("visible");
    }
  
    // 🔹 Aggiunge le icone info (solo accanto a pplrlabel)
    function addInfoIcon(wrapper, sectionClass) {
      const label = wrapper.querySelector(".pplrlabel"); // 👈 SOLO pplrlabel visibile
      if (!label || label.querySelector(".info-btn")) return;
  
      const infoBtn = document.createElement("span");
      infoBtn.className = "info-btn";
      infoBtn.textContent = "i";
      infoBtn.title = `${t.mostra_dettagli} ${popupData[sectionClass]?.title || ""}`;
  
      infoBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        openInfoPopup(sectionClass);
      });
  
      label.appendChild(infoBtn);
      console.log(sectionClass);
      if (sectionClass=='pplr-collo'){
        console.log('Scopri come prendere le misure');
        //label.appendChild('<a href="#" class="info-btn">Scopri come prendere le misure</a>');
        // Seleziona l'elemento con classe .info-btn
        const elemento = document.querySelector('.pplr-collo .info-btn');

        if (elemento) {
          // Crea il nuovo elemento <a>
          const infoLink = document.createElement('a');
          infoLink.href = '#';
          infoLink.className = 'info-misure';
          infoLink.textContent = t.measureLink;
          
        
          // Aggiunge lo stesso evento del pulsante originale
          infoLink.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            // Richiama la stessa funzione del bottone originale
            openInfoPopup(sectionClass);
          });
        
          // Inserisce il link subito dopo l'elemento originale
          elemento.insertAdjacentElement('afterend', infoLink);
        }

      }
      console.log(`✅ [InfoPopup] Icona info aggiunta per .${sectionClass}`);
    }
  
    // 🔹 Scansiona le sezioni
    function scanForSections() {
      Object.keys(popupData).forEach((sectionClass) => {
        document.querySelectorAll(`.${sectionClass}`).forEach((wrapper) => {
          addInfoIcon(wrapper, sectionClass);
        });
      });
    }
  
    // 🔹 Osserva mutazioni per aggiornare automaticamente
    function startObserver() {
      scanForSections();
      const observer = new MutationObserver(() => scanForSections());
      observer.observe(document.body, { childList: true, subtree: true });
      console.log("👁️ [InfoPopup] Observer attivo");
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", startObserver);
    } else {
      startObserver();
    }
  })();
  